import { Component, OnInit } from '@angular/core';
import { ManifestoService } from 'src/app/service/manifesto/manifesto.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { PAGINA_HOME} from 'src/app/tools/URL';

@Component({
  selector: 'home-govbr',
  templateUrl: './home-govbr.component.html',
  styleUrls: ['./home-govbr.component.css']
})
export class HomeGovbrComponent implements OnInit {

  constructor(public manifestoService: ManifestoService, private route: ActivatedRoute, private authService: AuthService, private router: Router) { }

  ngOnInit() {

    this.manifestoService.carregarDados().subscribe(retorno => {
      retorno.sort((a, b) => a.numeroOrdem - b.numeroOrdem);
      this.manifestoService.listaManifesto = retorno;
    });


    const authorizationCode = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');

    if (authorizationCode) {

      this.authService.tokenAcessoGovBr(authorizationCode, state);

    } else {
      console.error('Código de autorização não encontrado.');
      this.router.navigate([PAGINA_HOME]);
    }

  }

}
